import { PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import { makeAutoObservable } from 'mobx';
import { decodeToken, isExpired } from "react-jwt";

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
        redirectUri: process.env.REACT_APP_REDIRECT_URL,
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

class LoginStore {
    msalUsername = ""
    userData = null
    loginError = ""
    msalAccessToken = null
    constructor() {
        makeAutoObservable(this)
    }

    async loginHandleRedirectPromise() {
        try {
            await msalInstance.initialize();
            const response = await msalInstance.handleRedirectPromise();
            
            if (response) {
                this.msalAccessToken = response.accessToken;
                this.msalUsername = response.account.username.toLowerCase();
                this.login();
            }
        } catch (error) {
            console.error('MSAL initialization error:', error);
        }
    }

    async msalLogin() {
        return new Promise(async (resolve, reject) => {
            try {
                await msalInstance.initialize();
                const loginResponse = await msalInstance.loginRedirect({
                    scopes: ['User.Read'],
                });
                    
                if (loginResponse) {
                    this.msalUsername = loginResponse.account.username.toLowerCase();
                    resolve(this.msalUsername);
                }
            } catch (error) {
                reject(error);
                console.error('Login failed:', error);
            }
        });

    };

    async login() {
        this.loginError = ""

        await axios.post(`/api/Login/loginValidation`, {
            accessToken: this.msalAccessToken
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async response => {
            if (response.data) {
                let token = response.data.token
                let refreshToken = response.data.refreshToken;
                const isTokenExpired = isExpired(token);

                if (!isTokenExpired) {
                    localStorage.setItem('token', token);
                    localStorage.setItem('refreshtoken', refreshToken);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    const decodedToken = decodeToken(token);

                    this.userData = decodedToken

                    axios.interceptors.request.use(config => {
                        if (token) {
                            config.headers['Authorization'] = 'Bearer ' + token;
                        }
                        return config;
                    }, error => {
                        return Promise.reject(error);
                    });

                    window.location.href = '/dashboard'
                }
            }
        }).catch(error => {
            if (error.response) {
                this.loginError = error.response.data.message
                console.error('Error:', error.response.data.message);
            }
        });
    }

    async setUserData(data) {
        this.userData = data
    }

    async logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshtoken');
        localStorage.removeItem('currentVoice');
        this.userData = null;
        window.location.reload();
    }
    async refreshToken()
    {
       var token = localStorage.getItem('token');
       var refreshToken = localStorage.getItem('refreshtoken');
       await axios.post(`/api/Login/RefreshToken`, {
            accessToken: token,
            refreshToken: refreshToken
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async response => {
            if (response.data) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('refreshtoken', response.data.refreshToken);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
                const decodedToken = decodeToken(response.data.token);
                this.userData = decodedToken
                
            }else
            {
                loginStore.setUserData(null);
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                window.location.reload();
            }
        }).catch(error => {
             if (error.response) {
                console.error('Error:', error.response.data.message);
                loginStore.setUserData(null);
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                window.location.reload();
            }

        
                  
        });
    }
}

const loginStore = new LoginStore();
export default loginStore